import {MailOutlined} from "@ant-design/icons";
import {capitalize} from "lodash";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import CommunicationCreateDrawer from "./CommunicationCreateDrawer";
import {useEventContext} from "../../../context/event/EventContext";
import {useCreateCommunicationWithTextEditorMutation,} from "../../../redux/api/events";
import {useMessageContext} from "../../../context/message/MessageContext";
import {CreateCommunicationWithTextEditor} from "../../../types/api/communications";
import dayjs from "dayjs";
import {isEventCommunicationCreation} from "../../Authentication/permissions";
import PermissionRoute from "../../Authentication/PermissionRoute";
import {Button, Tooltip} from "antd";

export default function ClusterCommunicationCreate({cluster}: { cluster: string }) {

  const {t} = useTranslation()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const {event} = useEventContext()
  const [createCommunicationWithTextEditor, {isLoading: isLoadingCreateCommunicationWithTextEditor}] = useCreateCommunicationWithTextEditorMutation()
  const setMessage = useMessageContext()
  const handleCreationWithTextEditor = async (values: Pick<CreateCommunicationWithTextEditor, 'body' | 'subject' | 'tags' | 'status'>) => {
    const {body, subject, tags, status} = values
    if (event?.uuid) {
      try {
        await createCommunicationWithTextEditor({
          cluster_templates: [cluster],
          body,
          datetime: dayjs().toISOString(),
          event: event.uuid,
          subject,
          status,
          tags
        }).unwrap()
        setMessage({success: capitalize(t('form.creationSuccessMessage'))})
        setIsDrawerOpen(false)
      } catch {
        setMessage({error: capitalize(t('form.creationFailMessage'))})
      }
    }
  }

  return <PermissionRoute isAuthorized={isEventCommunicationCreation}>
    <CommunicationCreateDrawer
      disabled={isLoadingCreateCommunicationWithTextEditor}
      onCreationWithTextEditor={handleCreationWithTextEditor}
      drawer={{
        open: isDrawerOpen,
        onClose: () => setIsDrawerOpen(false)
      }}
    />
    <Tooltip
      title={capitalize(t('actions.createItem', {item: t('events.communication', {count: 2})}))}
    >
      <Button
        onClick={() => setIsDrawerOpen(true)}
        icon={<MailOutlined/>}
        type={'text'}
      />
    </Tooltip>
  </PermissionRoute>
}